import React from 'react';
import numeral from 'numeral';
import { round } from 'lodash';

export default function CreditLimit({
  creditLimit
}) {
  const { max_potential_credit_limit } = creditLimit

  function maxPotentialCreditLimit() {
    const rounded = round(max_potential_credit_limit, 2)
    const split = numeral(rounded).format('0,0.00').split('.')
    return split[0]
  }

  return(
    <section className="cardSection _textAlign_center">
      <h2 className="subhead -darkBlue">Your credit limit is</h2>
      <div className="_displayFlex _justifyContent-center _alignItems-center">
        <span className="-primary _marginRight--xxsmall">₱</span>
        <h1 className="ultra -primary _marginBottom-none">
          { maxPotentialCreditLimit() }
        </h1>
      </div>
      <p className="byline --small _marginTop--small">This is the maximum amount we can lend to you at any given point in time.</p>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/features/account/components/CreditLimit.js